import React, { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import imageLeftOne from "../../assets/home/leftOne.webp";
import imageLeftTwo from "../../assets/home/leftTwo.webp";
import imageLeftThree from "../../assets/home/leftThree.webp";
import imageLeftFour from "../../assets/home/leftFour.webp";
import imageLeftFive from "../../assets/home/leftFive.webp";
import imageRightOne from "../../assets/home/rightOne.jpeg";

const Home = () => {
  const [isDragging, setIsDragging] = useState(false);
  const [dotColor, setDotColor] = useState("#008DFF");
  const [hours, setHours] = useState(23);
  const [minutes, setMinutes] = useState(59);
  const [seconds, setSeconds] = useState(59);

  useEffect(() => {
    const totalSeconds = seconds + minutes * 60 + hours * 60 * 60;
    const timer = setInterval(() => {      
      if (totalSeconds > 0) {
        const remainingSeconds = totalSeconds - 1;
        const newHours = Math.floor(remainingSeconds / (60 * 60));
        const newMinutes = Math.floor((remainingSeconds % (60 * 60)) / 60);
        const newSeconds = Math.floor(remainingSeconds % 60);
        setHours(newHours);
        setMinutes(newMinutes);
        setSeconds(newSeconds);
        setDotColor((prevColor) => (prevColor === "#008DFF" ? "#FFF" : "#008DFF"));
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [hours, minutes, seconds, dotColor]);

  const handleSlideChange = (index) => {
    const dots = document.querySelectorAll(".carousel .control-dots .dot");
    dots.forEach((dot, dotIndex) => {
      dot.style.transform = dotIndex === index ? "scale(1.3)" : "scale(1)";
    });
  };

  const handleDragStart = () => {
    setIsDragging(true);
  };

  const handleDragEnd = () => {
    setIsDragging(false);
  };

  return (
    <div className="carousel-container my-2">
      <style>
        {`
          .carousel .control-dots .dot {
            background-color: ${isDragging ? "#ccc" : "#008DFF"};
            transition: all 0.3s;
          }
        
          .carousel .control-dots .dot:hover,
          .carousel .control-dots .dot.carousel__dot--selected {
            background-color: #008DFF;
            transform: scale(1.3);
          }
        `}
      </style>

      <div className="h-full lg:w-11/12 mx-auto flex items-center justify-between">
        <div className="lg:w-3/4 maxLg:w-full">
          <Carousel
            showArrows={false}
            showThumbs={false}
            // ---------------------
            // Later change these to play carousel
            autoPlay={true}
            infiniteLoop={true}
            // -----------------------
            interval={5000}
            showStatus={false}
            transitionTime={2000}
            renderArrowPrev={() => null}
            renderArrowNext={() => null}
            onChange={handleSlideChange}
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            className="rounded-xl w-full h-auto"
          >
            <div className="carousel-item rounded-xl m-2">
              <img
                className="rounded-xl h-auto w-auto object-cover"
                src={imageLeftOne}
                alt="Carousel Image 1"
              />
            </div>
            <div className="carousel-item rounded-xl m-2">
              <img
                className="rounded-xl h-auto w-auto object-cover"
                src={imageLeftTwo}
                alt="Carousel Image 2"
              />
            </div>
            <div className="carousel-item rounded-xl m-2">
              <img
                className="rounded-xl h-auto w-11/12 object-cover"
                src={imageLeftThree}
                alt="Carousel Image 3"
              />
            </div>
            <div className="carousel-item rounded-xl m-2">
              <img
                className="rounded-xl h-auto w-auto object-cover"
                src={imageLeftFour}
                alt="Carousel Image 4"
              />
            </div>
            <div className="carousel-item rounded-xl m-2">
              <img
                className="rounded-xl h-auto w-auto object-cover"
                src={imageLeftFive}
                alt="Carousel Image 4"
              />
            </div>
          </Carousel>
        </div>

        <div className="flex justify-end md:w-1/3 lg:w-1/4 maxLg:hidden relative">
          <img
            className="rounded-xl h-auto w-11/12 object-cover"
            src={imageRightOne}
            alt="Image Right"
          />

          <div className="text-center ml-3 absolute bottom-0 w-full left-0">
            <div className="flex justify-center items-center">
              <button className="text-white bg-blueColor m-2 p-2 rounded-lg font-medium">
                {hours.toString().padStart(2, "0")}
              </button>
              <span style={{ color: dotColor, fontSize: "1.5rem" }}>:</span>{" "}
              <button className="text-white bg-blueColor m-2 p-2 rounded-lg font-medium">
                {minutes.toString().padStart(2, "0")}
              </button>
              <span style={{ color: dotColor, fontSize: "1.5rem" }}>:</span>{" "}
              <button className="text-white m-2 bg-blueColor p-2 rounded-lg font-medium">
                {seconds.toString().padStart(2, "0")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
